
import {gql} from "apollo-angular";



const GET_NEW_REQUEST_NOTIFICATION = gql`
subscription newNotification($receiver: ID!) {
  newNotification(receiver: $receiver) {
    id
    description
    reference
    type {
      id
    }
  }
}
`







export {GET_NEW_REQUEST_NOTIFICATION}
